import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


const appRoutes: Routes = [
    {
      path: 'auth',
      loadChildren: 'app/auth/auth.module#AuthModule'
    },
    {
      path: 'office',
      loadChildren: 'app/office/office.module#OfficeModule'
    },
    {
      path: 'office_management',
      loadChildren: 'app/office-management/office-management.module#OfficeManagementModule'
    },
    { path: '',   redirectTo: '/office/home', pathMatch: 'full' },
    { path: '**', redirectTo: '/office/home', pathMatch: 'full' }
  ];
  
  @NgModule({
    imports: [
      RouterModule.forRoot(
        appRoutes,
        {
          enableTracing: false  
        }
      )
    ],
    exports: [
      RouterModule
    ]
  })
  export class AppRoutingModule { }


// WEBPACK FOOTER //
// /app/src/app/app-routing.module.ts